import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { manageFootballCompetitionService } from "../../../../../commons";
import { StatusEnum } from "../../../../../commons/enums/status-enum";
import { ISeasonTeamsInfo } from "../../../../../api-services/football/admin/manage-football-competition-service";

export interface IManageCompetitionSeasonTeamsState {
  competitionSeasonTeamInviteResponseStatus: StatusEnum;
}

export interface IManageCompetitionTeamsInviteOption {
  competitionId: number;
  seasonId: number;
  teamsInfo: ISeasonTeamsInfo;
  urlParams?: {
    hostTeamId?: number;
  };
}

const initialState: IManageCompetitionSeasonTeamsState = {
  competitionSeasonTeamInviteResponseStatus: StatusEnum.Idle,
};

export const competitionSeasonTeamsInvite = createAsyncThunk(
  "competitions/competitionSeasonTeamInvite",
  async (options: IManageCompetitionTeamsInviteOption, thunkAPI) => {
    try {
      const competitionTeamList = await manageFootballCompetitionService.setTeamInvite(
        options.competitionId,
        options.seasonId,
        options.teamsInfo,
        options.urlParams
      );
      return competitionTeamList;
    } catch (e) {
      return thunkAPI.rejectWithValue(e);
    }
  }
);

const manageCompetitionSeasonTeamsInviteSlice = createSlice({
  name: "competitionSeasonTeamInvite",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(competitionSeasonTeamsInvite.pending, (state) => {
        state.competitionSeasonTeamInviteResponseStatus = StatusEnum.Loading;
      })
      .addCase(competitionSeasonTeamsInvite.fulfilled, (state) => {
        state.competitionSeasonTeamInviteResponseStatus = StatusEnum.Succeeded;
      })
      .addCase(competitionSeasonTeamsInvite.rejected, (state) => {
        state.competitionSeasonTeamInviteResponseStatus = StatusEnum.Failed;
      });
  },
});

export default manageCompetitionSeasonTeamsInviteSlice.reducer;
